// Styles for ListView go here.
import styled from 'styled-components';

export const StyledListView = styled.div`
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
`;
